import { fromJS } from "immutable";
import { isEmpty, cloneDeep } from "lodash";
import { createReducer } from "./../../../redux/reducers/functions";
import {
  PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
  PRESENCE_SET_DETAILS_WEEK,
  PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_WEEK,
  PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_WEEK,
  PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_WEEK,
  PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_WEEK,
  PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_WEEK,
  PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_WEEK,
  PRESENCE_SET_TRIP_UPDATED_DETAILS_WEEK,
  PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_WEEK,
  PRESENCE_RESET_TRIP_ERRORS_DETAILS_WEEK,
  PRESENCE_SET_VALIDATE_TRIPS_SUCCESS_WEEK,
  PRESENCE_SET_VALIDATE_TRIPS_FAILURE_WEEK,
  PRESENCE_RESET_TRIPS_VALIDATION_SUCCESS_WEEK,
  PRESENCE_RESET_TRIPS_VALIDATION_FAILURE_WEEK,
  PRESENCE_SET_VALIDATE_ATTENDANCE_SUCCESS_WEEK,
  PRESENCE_SET_VALIDATE_ATTENDANCE_FAILURE_WEEK,
  PRESENCE_RESET_ATTENDANCE_VALIDATION_SUCCESS_WEEK,
  PRESENCE_RESET_ATTENDANCE_VALIDATION_FAILURE_WEEK,
  PRESENCE_SET_VALIDATE_MEAL_PACKAGES_SUCCESS_WEEK,
  PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_SUCCESS_WEEK,
  PRESENCE_ERASE_DETAILS_WEEK,
  PRESENCE_SET_ONE_WEEK_IS_LOADING
} from "../actions/presenceDetailsWeek";

const initialState = fromJS({
  userId: null,
  userName: null,
  userRoleId: null,
  userData: [],
  isLoading: false,
  weekIsLoading: false,
  currentIndexWeek: null,
  updated: null,
  updateAttendanceErrors: null,
  updateMealPackageErrors: null,
  updateTripErrors: null,
  tripValidationSuccess: null,
  tripValidationFailure: null,
  attendanceValidationSuccess: null,
  attendanceValidationFailure: null,
  mealPackageValidationSuccess: null,
  mealPackageValidationFailure: null
});

const detailsWeekList = {
  [PRESENCE_SET_DETAILS_WEEK]: (state, action) => {
    const { user_id, user_fullname, user_role_id, data: newWeek } = action.payload;
    let weeks = state.get("userData") || [];
    const weeksToRemove = newWeek.map(w => w.week);

    weeks = [...weeks.filter(w => weeksToRemove.indexOf(w.week) === -1), ...newWeek];
    const sortedWeeks = weeks.sort((w1, w2) => +w1.week - +w2.week);

    return state
      .set("userId", user_id)
      .set("userName", user_fullname)
      .set("userRoleId", user_role_id)
      .set("userData", sortedWeeks);
  }
};
const eraseDetailsWeekList = {
  [PRESENCE_ERASE_DETAILS_WEEK]: state => {
    return state.set("userData", []);
  }
};

const isLoading = {
  [PRESENCE_SET_DETAIL_WEEK_IS_LOADING]: (state, action) => {
    return state.set("isLoading", action.payload);
  }
};

const weekIsLoading = {
  [PRESENCE_SET_ONE_WEEK_IS_LOADING]: (state, action) => {
    const { indexWeek, weekIsLoading } = action.payload;
    if (weekIsLoading === false) {
      return state.set("weekIsLoading", false).set("currentIndexWeek", Math.random() < 0.5 ? null : undefined);
    }
    return state.set("weekIsLoading", weekIsLoading).set("currentIndexWeek", indexWeek);
  }
};

const updateAttendanceWeek = {
  [PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_WEEK]: (state, action) => {
    const { payload, weekIndex, dayIndex } = action;
    const dayTime = payload.slot.id === 1 ? "morning" : "afternoon";
    const stateUpdated = state.updateIn(
      ["userData", weekIndex.toString(), "data", dayIndex.toString(), "attendances", dayTime],
      () => payload
    );

    return stateUpdated;
  }
};

const updateAttendanceErrors = {
  [PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_WEEK]: (state, action) => {
    const { payload } = action;

    return state.set("updateAttendanceErrors", payload);
  }
};

const resetAttendanceErrors = {
  [PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_WEEK]: state => {
    return state.set("updateAttendanceErrors", null);
  }
};

const updateMealPackageWeek = {
  [PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_WEEK]: (state, action) => {
    const { payload, weekIndex, dayIndex } = action;
    const stateUpdated = state.updateIn(
      ["userData", weekIndex.toString(), "data", dayIndex.toString(), "meal_packages", "0"],
      () => payload.meal_package
    );

    return stateUpdated;
  }
};

const updateMealPackageErrors = {
  [PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_WEEK]: (state, action) => {
    const { payload } = action;

    return state.set("updateMealPackageErrors", payload);
  }
};

const resetMealPackageErrors = {
  [PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_WEEK]: state => {
    return state.set("updateMealPackageErrors", null);
  }
};

const updateTripWeek = {
  [PRESENCE_SET_TRIP_UPDATED_DETAILS_WEEK]: (state, action) => {
    const { payload, weekIndex, dayIndex, tripIndex } = action;
    const stateUpdated = state.updateIn(
      ["userData", weekIndex.toString(), "data", dayIndex.toString(), "trips", tripIndex.toString()],
      () => payload
    );

    return stateUpdated;
  }
};

const updateTripErrors = {
  [PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_WEEK]: (state, action) => {
    const { payload } = action;

    return state.set("updateTripErrors", payload);
  }
};

const resetTripErrors = {
  [PRESENCE_RESET_TRIP_ERRORS_DETAILS_WEEK]: state => {
    return state.set("updateTripErrors", null);
  }
};

const validateTripsSuccess = {
  [PRESENCE_SET_VALIDATE_TRIPS_SUCCESS_WEEK]: (state, action) => {
    const { payload } = action;

    return state
      .updateIn(["userData", payload.indexWeek.toString(), "data"], weekData => {
        return weekData.map(item => {
          if (!isEmpty(item.trips))
            return {
              ...item,
              trips: item.trips.map(trip => ({ ...trip, validated: true }))
            };
          return item;
        });
      })
      .set("tripValidationSuccess", payload.text);
  }
};

const validateTripsFailure = {
  [PRESENCE_SET_VALIDATE_TRIPS_FAILURE_WEEK]: (state, action) => {
    const { payload } = action;

    return state.set("tripValidationFailure", payload);
  }
};

const resetTripValidationSuccess = {
  [PRESENCE_RESET_TRIPS_VALIDATION_SUCCESS_WEEK]: state => {
    return state.set("tripValidationSuccess", null);
  }
};

const resetTripValidationFailure = {
  [PRESENCE_RESET_TRIPS_VALIDATION_FAILURE_WEEK]: state => {
    return state.set("tripValidationFailure", null);
  }
};

const validateAttendancesSuccess = {
  [PRESENCE_SET_VALIDATE_ATTENDANCE_SUCCESS_WEEK]: (state, action) => {
    const { payload } = action;

    return state.set("attendanceValidationSuccess", payload.text);
  }
};

const validateAttendancesFailure = {
  [PRESENCE_SET_VALIDATE_ATTENDANCE_FAILURE_WEEK]: (state, action) => {
    const { payload } = action;

    return state.set("attendanceValidationFailure", payload);
  }
};

const resetAttendanceValidationSuccess = {
  [PRESENCE_RESET_ATTENDANCE_VALIDATION_SUCCESS_WEEK]: state => {
    return state.set("attendanceValidationSuccess", null);
  }
};

const resetAttendanceValidationFailure = {
  [PRESENCE_RESET_ATTENDANCE_VALIDATION_FAILURE_WEEK]: state => {
    return state.set("attendanceValidationFailure", null);
  }
};

const validateMealPackagesSuccess = {
  [PRESENCE_SET_VALIDATE_MEAL_PACKAGES_SUCCESS_WEEK]: (state, action) => {
    const { payload } = action;

    return state
      .updateIn(["userData", payload.indexWeek.toString(), "data"], weekData => {
        return weekData.map(item => ({
          ...item,
          meal_packages: isEmpty(item.meal_packages)
            ? item.meal_packages
            : [
                {
                  ...item.meal_packages[0],
                  validated: true
                }
              ]
        }));
      })
      .set("mealPackageValidationSuccess", payload.text);
  }
};

const resetMealPackageValidationSuccess = {
  [PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_SUCCESS_WEEK]: state => {
    return state.set("mealPackageValidationSuccess", null);
  }
};

const presenceReducer = createReducer(initialState, {
  ...detailsWeekList,
  ...isLoading,
  ...updateAttendanceWeek,
  ...updateAttendanceErrors,
  ...resetAttendanceErrors,
  ...updateMealPackageWeek,
  ...updateMealPackageErrors,
  ...resetMealPackageErrors,
  ...updateTripWeek,
  ...updateTripErrors,
  ...resetTripErrors,
  ...validateTripsSuccess,
  ...validateTripsFailure,
  ...resetTripValidationSuccess,
  ...resetTripValidationFailure,
  ...validateAttendancesSuccess,
  ...validateAttendancesFailure,
  ...resetAttendanceValidationSuccess,
  ...resetAttendanceValidationFailure,
  ...validateMealPackagesSuccess,
  ...resetMealPackageValidationSuccess,
  ...eraseDetailsWeekList,
  ...weekIsLoading
});

export default presenceReducer;



// WEBPACK FOOTER //
// src/modules/presence/reducers/presenceDetailsWeek.js